<template>
  <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-col cols="12" class="mb-4">
      <PageTitle title="Lista de clientes" />
    </b-col>

    <b-col cols="12" class="mb-4">
      <b-button
        class="mr-3"
        variant="danger"
        @click="$refs.videoManual.toggleOpen({
          url: 'https://www.youtube.com/watch?v=0W5UQUlRxH4&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=5',
          title: 'Lista de clientes'
        })"
      >
        <i class="fas fa-play mr-1"></i>
        Ver video
      </b-button>
      <a
        class="btn btn-success"
        href="https://api.construp.com.br/assets/CLIENTES.pdf"
        target="_blank"
        download
        ><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a
      >
    </b-col>
    <b-col cols="12">
      <PeriodsFilters
        ref="periodsFilters"
        :setDatesAutomatic="false"
        :startDate.sync="filters.startDate"
        :endDate.sync="filters.endDate"
        :limparDados="limpar"
        @click.native="get()"
      />
    </b-col>

    <b-col cols="12" class="mt-5">
      <h4 class="c-black">Tipos de clientes</h4>
       <div class="mt-3">
        <h4>
          <b-badge
            :variant="
              filters.userTypes.includes(USER_TYPES.CLIENT)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addUserType(USER_TYPES.CLIENT)"
          >
            Cliente
          </b-badge>
          <b-badge
            :variant="
              filters.userTypes.includes(USER_TYPES.PROFESSIONAL)
                ? 'primary'
                : 'light'
            "
            class="mx-3 pointer"
            @click="addUserType(USER_TYPES.PROFESSIONAL)"
          >
            Profissional
          </b-badge>
          <b-badge
            :variant="
              filters.userTypes.includes(USER_TYPES.SHOPKEEPER)
                ? 'primary'
                : 'light'
            "
            class="mx-3 pointer"
            @click="addUserType(USER_TYPES.SHOPKEEPER)"
          >
            Empresa
          </b-badge>
          <b-badge
            :variant="
              filters.userTypes.includes(USER_TYPES.CLIENT) &&
              filters.userTypes.includes(USER_TYPES.PROFESSIONAL) &&
              filters.userTypes.includes(USER_TYPES.SHOPKEEPER)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addAllTypes()"
          >
            Todos
          </b-badge>
        </h4>
      </div>
    </b-col>

    <b-col cols="6" class="mt-3">
      <h5 class="c-black">Nome do cliente</h5>
      <input
        type="text"
        class="form-control"
        placeholder="Ex: João Silva"
        v-model="filters.name"
        @keydown.enter="get()"
        @keyup="searchTimeOut()"
      />
    </b-col>

    <b-col cols="6" class="mt-3">
      <label>Vendedor:</label>
      <select class="form-control" v-model="filters.vendedor">
        <option value="">-- Vendedor -- </option>
        <option v-for="(item, i) in balconistas" :key="i" :value="item.id">
          {{item.name}}
        </option>
      </select>
    </b-col>

    <b-col cols="12" class="mt-3">
      <b-button variant="success" @click="get()" :disabled="loading">
        <i class="fas fa-search mr-2"></i>
        Pesquisar
      </b-button>
      <b-button variant="warning" class="ml-2" @click="cleanFilters()">
        <i class="fas fa-trash mr-2"></i>
        Limpar pesquisa
      </b-button>
    </b-col>
    <b-col class="mt-5 mb-2 d-flex align-items-center justify-content-between">
      <h3 class="title font-weight-bold">Clientes encontrados {{table.records.length}}</h3>
      <b-button
        v-if="!generatingSpreadsheet"
        pill
        variant="success"
        @click="generateSpreadsheet()"
      >
        <i class="fas fa-file-download mr-2"></i>
        Baixar planilha
      </b-button>
      <b-spinner v-else variant="success" label="Spinning"></b-spinner>
    </b-col>
    <b-col cols="12">
      <b-table
        striped
        responsive
        hover
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>
        <template #cell(type)="data">
          <span>{{ getUserTypeString(data.item.type) }}</span>
        </template>
        <template #cell(clientId)="data">
          <b-button variant="light"  @click="blockClient(data.item.id, data.item.status)"><i class="fas fa-lock text-danger" v-if="data.item.status"></i> <i v-else class="fas fa-lock-open text-success"></i></b-button>
        </template>
        <template #cell(createDate)="data">
          <span>{{ data.item.createdAt }}</span>
        </template>
        <template #cell(clerkId)="data">
          <span>{{ formatarBalconista(data.item.clerkId) }}</span>
        </template>
        <template #cell(action)="data">
          <b-button
              variant="outline-dark"
              size="sm"
              title="Detalhes do cliente"
              :disabled="!whatClerkPermission()"
              class="mr-2 mb-2"
              @click="$refs.clientDetails.toggleOpen({ data: data.item })"
            >
              <i class="fas fa-eye"></i>
            </b-button>
        </template>
      </b-table>
    </b-col>
    <VideoManual ref="videoManual"/>
    <ClientDetails ref="clientDetails"/>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import * as XLSX from 'xlsx';
import USER_TYPES from 'Enums/UserTypes.js';
import makeToast from '../../../mixins/makeToast';
import PeriodsFilters from 'Components/Inputs/PeriodsFilters.vue';
import PageTitle from 'Components/PageTitle.vue';
import VideoManual from '@/components/VideoManual.vue';
import ClientDetails from '@/components/ClientDetails.vue';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';

export default {
  name: 'ClientList',
  mixins: [makeToast],
  components: {
    PageTitle,
    PeriodsFilters,
    VideoManual,
    ClientDetails
  },
  data() {
    return {
      USER_TYPES,
      loading: false,
      isBlock: true,
      limpar: false,
      generatingSpreadsheet: false,
      table: {
        headers: [
          {
            key: 'createdAt',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'status',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'id',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'clientId',
            label: 'Acesso',
            sortable: false
          },
          {
            key: 'name',
            label: 'Nome completo',
            sortable: true,
          },
          {
            key: 'cpf',
            label: 'CPF/CNPJ',
            sortable: false,
            headerClass: "d-none d-md-table-cell",
            tdClass: "d-none d-md-table-cell" ,
            thClass: "d-none d-md-table-cell"
          },
          {
            key: 'email',
            label: 'E-mail',
            sortable: false,
            headerClass: "d-none d-md-table-cell",
            tdClass: "d-none d-md-table-cell" ,
            thClass: "d-none d-md-table-cell"
          },
          {
            key: 'cep',
            label: 'CEP',
            sortable: false,
            headerClass: "d-none d-md-table-cell",
            tdClass: "d-none d-md-table-cell" ,
            thClass: "d-none d-md-table-cell"
          },
          {
            key: 'address',
            label: 'Endereço',
            sortable: false,
            headerClass: "d-none d-md-table-cell",
            tdClass: "d-none d-md-table-cell" ,
            thClass: "d-none d-md-table-cell"
          },
          {
            key: 'telephone',
            label: 'Telefone',
            sortable: false,
          },
          {
            key: 'type',
            label: 'Tipo de cliente',
            sortable: true,
          },
          {
            key: 'clerkId',
            label: 'Vendedor',
            sortable: true,
          },
          {
            key: 'createDate',
            label: 'Cadastrou-se em',
            sortable: true,
            headerClass: "d-none d-md-table-cell",
            tdClass: "d-none d-md-table-cell" ,
            thClass: "d-none d-md-table-cell"
          },
          {
            key: 'action',
            label: 'Ações',
            sortable: true,
            headerClass: "d-md-none ",
            tdClass: "d-md-none " ,
            thClass: "d-md-none "
          },
        ],
        records: [],
      },
      filters: {
        name: '',
        userTypes: [],
        vendedor: '',
        startDate: '',
        endDate: ''
      },
      timer: null,
      idClient: [],
      balconistas: []
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  mounted() {
    this.getAll();
  },
  methods: {
    ...mapActions('shopkeeper', ['getAllClients', 'blockedClients']),
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.get();
      }, 800);
    },

    blockClient(data, status) {
      const req = {
        user_id: this.userTypeId(),
        isBlock: !status,
        id_client: data
      }

      this.blockedClients(req)
      .then((resp => {
        if(req.isBlock == true) {
          this.makeToast(
            'Sucesso!',
            'Cliente bloqueado',
            'success'
          );
        } else {
            this.makeToast(
                'Sucesso!',
                'Cliente desbloqueado',
                'success'
              );
          }
      }
      ))
      .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao atualizar os clientes',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
          this.get();
        });
    },

    addUserType(userType) {
      if (this.filters.userTypes.includes(userType)) {
        const index = this.filters.userTypes.indexOf(userType);
        this.filters.userTypes.splice(index, 1);
        this.get();
        return;
      }

      this.filters.userTypes.push(userType);
      this.get();
    },
    addAllTypes() {
      const validUserTypes = [USER_TYPES.CLIENT, USER_TYPES.PROFESSIONAL];

      validUserTypes.forEach((value) => {
        if (this.filters.userTypes.includes(value)) return;

        this.filters.userTypes.push(value);
      });

      this.get();
    },
    formatarBalconista(id) {
      const balconistaEncontrado = this.balconistas.find(balconista => balconista.id === id);
      return balconistaEncontrado ? balconistaEncontrado.name : '-';
    },
    getAll(){
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getClerk', this.userTypeId())
        .then((response) => {
          this.balconistas = response.data;

          this.get();
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao trazer os dados', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    get() {
      this.loading = true;

      const request = {
        userId: this.userTypeId(),
        ...this.filters,
      };

      this.getAllClients(request)
        .then((response) => {
          this.table.records = response.data.data || {};
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os clientes',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    generateSpreadsheet() {
      this.generatingSpreadsheet = true;

      const clientsData = XLSX.utils.json_to_sheet(
        this.convertColumnsNames(this.table.records)
      );
      const excelFile = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(excelFile, clientsData, 'Lista de clientes');

      const currentDate = new Date().toLocaleDateString('pt-BR');
      const fileName = `Lista de clientes - ${this.dadosUsuario.informacoes.nome_fantasia} - ${currentDate}`;

      setTimeout(() => {
        this.generatingSpreadsheet = false;
      }, 1000);

      XLSX.writeFile(excelFile, `${fileName}.xlsx`);
    },
    /**
     * @param {Array} records
     * @returns {Array}
     */
    convertColumnsNames(records) {
      if (!records || !records.length) return [];

      const returnArray = [];

      records.forEach((record) => {
        const cell = {};
        Object.keys(record).forEach((key) => {
          const tableColumn = this.table.headers.find((x) => x.key === key);
          if (tableColumn) cell[`${tableColumn.label}`] = record[key];
        });

        returnArray.push(cell);
      });

      return returnArray;
    },
    cleanFilters() {
      this.limpar = !this.limpar;
      this.filters.name = '';
      this.filters.startDate = '';
      this.filters.endDate = '';
      this.filters.userTypes = [];
      this.get();
    },
    getUserTypeString(userType) {
      const strings = {
        [USER_TYPES.CLIENT]: 'Cliente',
        [USER_TYPES.PROFESSIONAL]: 'Profissional',
        [USER_TYPES.SHOPKEEPER]: 'Empresa',
      };

      return strings[userType] || 'Tipo não encontrado';
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    whatClerkPermission() {
      if (this.$route.meta.userType == UserTypes.BALCONISTA) {
        const permissionClerk = JSON.parse(
          localStorage.getItem('permissionClerk')
        );
        const permission = permissionClerk.find(
          (element) => element.name == NamePermission.CUSTOMIZACAO_EMPRESA
        );

        if (
          this.$route.meta.userType == UserTypes.BALCONISTA &&
          permission.type == TypePermission.BALCONISTA
        ) {
          return false;
        }
      }
      return true;
    }, 
  }
};
</script>
